import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { EnhancedBanner } from "@/libraries/design/components/enhanced-banner/src/enhanced-banner";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const HomePageBannerAlert = () => {
    const intl = useIntl();

    if (checkFeatureFlagGate(featureFlags.gwp10062Awf1Banner)) {
        return (
            <UFOSegment name="homepage-banner-awf1">
                <EnhancedBanner
                    uniqueIdentifier="homepage-banner-awf1"
                    heading="Celebrating 1 year of partnership"
                    subheading="Unleashing our AI-powered System of Work to prepare Williams for the 2026 season."
                    ctaLinkHref="https://www.atlassian.com/enterprise/atlassian-williams-racing"
                    ctaLinkText="See how with Rovo"
                    productKey="home"
                    logoSrc="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHO4.svg"
                    logoAlt="Atlassian Williams F1 Team Official Title & Technology Partner"
                    backgroundColor="black"
                    shapeColor1="blue700"
                    shapeColor2="neutral-light0"
                    shapeColor3="secondary-navy"
                />
            </UFOSegment>
        );
    }

    if (checkFeatureFlagGate(featureFlags.gwp9365TeamOnTourSydneyBanner)) {
        return (
            <UFOSegment name="homepage-banner-for-team-on-tour-sydney">
                <EnhancedBanner
                    uniqueIdentifier="homepage-banner-for-team-on-tour-sydney"
                    heading={intl.formatMessage({
                        id: "HomePage.banner-alert.team-on-tour-sydney.heading",
                        defaultMessage: "Join us 11 March at ICC Sydney."
                    })}
                    subheading={intl.formatMessage({
                        id: "HomePage.banner-alert.team-on-tour-sydney.subheading",
                        defaultMessage:
                            "Discover game-changing AI, connect with your peers, and unleash the potential of every team."
                    })}
                    ctaLinkHref={
                        "https://events.atlassian.com/teamontour-sydney?utm_medium=event-web-referral&utm_source=cross-promo&event_context=701qb00000wjv6ayar&utm_campaign=K:event|H:in-person|N:tt_sydney|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=WAC_Banner&event_id=304560"
                    }
                    ctaLinkText="Learn more"
                    productKey="home"
                    logoSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/31m8r0ja03yabf6a0f7137tc1l76243f.png"
                    logoAlt="Team on Tour Sydney"
                    backgroundColor="lightBlue"
                />
            </UFOSegment>
        );
    }

    if (checkFeatureFlagGate(featureFlags.gwp9226Team26Banner)) {
        return (
            <UFOSegment name="homepage-banner-for-team-26">
                <EnhancedBanner
                    uniqueIdentifier="homepage-banner-for-team-26"
                    heading={intl.formatMessage({
                        id: "HomePage.banner-alert.team-26.heading",
                        defaultMessage: "May 5 - 7  •  Anaheim, California"
                    })}
                    subheading={intl.formatMessage({
                        id: "HomePage.banner-alert.team-26.subheading",
                        defaultMessage:
                            "Get the most savings on your in-person pass & experience the AI tools fueling better teamwork."
                    })}
                    subheadingMobile={intl.formatMessage({
                        id: "HomePage.banner-alert.team-26.subheading",
                        defaultMessage: "Save big on your in-person pass"
                    })}
                    ctaLinkHref={
                        "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=cross-promo&event_context=701qb00000tzh4byar&utm_campaign=K:event|H:in-person|N:team_26|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=enhanced_banner_hero&event_id=288640"
                    }
                    ctaLinkText="Register now"
                    productKey="home"
                    logoSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/p8na60e0488c54y2pj2l0oy184f23bg3.png"
                    logoAlt="Team 26"
                    backgroundImageDesktop="https://dam-cdn.atl.orangelogic.com/AssetLink/65yptj77sdkwv3tr84k58eae2i3d2d17.webp"
                    backgroundImageTablet="https://dam-cdn.atl.orangelogic.com/AssetLink/5bio0v54ttg7k5e1s1r380ode2h46xml.webp"
                    backgroundImageMobile="https://dam-cdn.atl.orangelogic.com/AssetLink/27pf0qlj6ilylq2hor6k233caw6706j3.webp"
                    backgroundColor="lightBlue"
                />
            </UFOSegment>
        );
    }
};
